import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { IMG } from "../lib/data";
import PageHero from "./PageHero";

const LegalPage = ({ data }) => {
  useLanguage(); // ensures re-render on language change
  return (
    <div data-testid="legal-page">
      <PageHero label={data.label} title={data.heading} image={IMG.cityNight} />
      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          {data.updated && (
            <p className="text-xs text-slate-400 mb-6" data-testid="legal-updated">{data.updated}</p>
          )}
          {data.intro && (
            <p className="text-base text-slate-200 leading-relaxed mb-10">{data.intro}</p>
          )}
          <div className="space-y-10">
            {data.sections.map((s, i) => (
              <div key={i} data-testid={`legal-section-${i}`}>
                <h2 className="font-heading text-xl font-bold text-white mb-3">{s.title}</h2>
                <p className="text-sm text-slate-300 leading-relaxed whitespace-pre-line">{s.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalPage;
